import React from 'react';

const BackIcon = React.memo( props => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path d="M15 8H1M1 8L8 15M1 8L8 1" stroke="#212121" strokeLinecap="round" strokeLinejoin="round"/>
</svg>)

export default BackIcon;

BackIcon.defaultProps = {
    width:'16px',
    height:'16px'
};